import {Injectable} from "@angular/core";
import { PsEditFieldsMetadata, DefaultService} from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PSConfigService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllPsEditFieldsMetadata();
    }

    getAllPsEditFieldsMetadata() {
        return this.powerSupplyService.getAllPsEditFieldsMetadata().pipe(map(result => result));
    }

    createPsEditFieldsMetadata(model: PsEditFieldsMetadata) {
        return this.powerSupplyService.createPsEditFieldsMetadata(model).pipe(map(result => result));
    }

    updatePsEditFieldsMetadata(model: PsEditFieldsMetadata) {
        return this.powerSupplyService.updatePsEditFieldsMetadata(model).pipe(map(result => result));
    }

    deleteBatteryType(id: number) {
        return this.powerSupplyService.deletePsEditFieldsMetadata(id).pipe(map(result => result));
    }
}
